export default () => ({
	token: window.localStorage.getItem(process.env.VUE_APP_TOKEN_KEY)
})
